import React from "react";
import { connect } from "react-redux";
import PT from "prop-types";
import { Link } from "@quintype/components";

import { NJLogo, QALogo, NHLogo } from "../logos";
import get from "lodash/get";

import "./styles.m.css";

function AppLogoBase({ color, publisherAttributes = {}, hideDivider }) {
  return (
    <Link href="/" styleName="publisher-logo">
      {publisherAttributes.lang === "hi" ? <NJLogo color={color} width={150} height={37} /> : null}
      {publisherAttributes.lang === "ur" ? <QALogo color={color} height={32} width={130} /> : null}
      {publisherAttributes.lang === "en" ? <NHLogo color={color} width={300} height={32} /> : null}
      {hideDivider ? null : <div styleName="divider" />}
    </Link>
  );
}

AppLogoBase.propTypes = {
  color: PT.string,
  publisherAttributes: PT.object,
  hideDivider: PT.bool
};

function mapStateToProps(state) {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"])
  };
}

export const AppLogo = connect(
  mapStateToProps,
  null
)(AppLogoBase);
